// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Nynf3InjuryResultInDisfigurementOrDisabilityType,
    Nynf3InjuryResultInDisfigurementOrDisabilityTypeFromJSON,
    Nynf3InjuryResultInDisfigurementOrDisabilityTypeToJSON,
    ProviderNynf3ClaimTemplateBody,
    ProviderNynf3ClaimTemplateBodyFromJSON,
    ProviderNynf3ClaimTemplateBodyToJSON,
    ProviderNynf3DiagnosisAndCurrentCondition,
    ProviderNynf3DiagnosisAndCurrentConditionFromJSON,
    ProviderNynf3DiagnosisAndCurrentConditionToJSON,
    ProviderNynf3TemplateServiceLine,
    ProviderNynf3TemplateServiceLineFromJSON,
    ProviderNynf3TemplateServiceLineToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderNynf3ClaimTemplateBodyWithClaimBody
 */
export interface ProviderNynf3ClaimTemplateBodyWithClaimBody extends ProviderNynf3ClaimTemplateBody {
    /**
     * Date of accident
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f00DateOfAccident?: string;
    /**
     * Claim number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f00ClaimNumber?: string;
    /**
     * Diagnosis and current condition codes
     * OpenAPI data type: {array}
     * @type {Array<ProviderNynf3DiagnosisAndCurrentCondition>}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f05DiagnosisAndConcurrentConditions?: Array<ProviderNynf3DiagnosisAndCurrentCondition>;
    /**
     * Date symptoms first appeared
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f06DateSymptomsFirstAppeared?: string;
    /**
     * Date patient was consulted
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f07DatePatientConsulted?: string;
    /**
     * Did the patient ever have a similar condition?
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f08PatientEverHadSimilarCondition?: boolean;
    /**
     * Describe the condition.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f08PatientEverHadSimilarConditionDescription?: string;
    /**
     * Was the condition the result of an auto accident?
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f09ConditionDueToAutoAccident?: boolean;
    /**
     * Describe the condition.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f09ConditionDueToAutoAccidentDescription?: string;
    /**
     * Was the condition due to employment?
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f10ConditionDueToEmployment?: boolean;
    /**
     * Describe the condition.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f10ConditionDueToEmploymentDescription?: string;
    /**
     * 
     * OpenAPI data type: {Nynf3InjuryResultInDisfigurementOrDisabilityType}
     * @type {Nynf3InjuryResultInDisfigurementOrDisabilityType}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f11InjuryResultInDisfigurementOrDisability?: Nynf3InjuryResultInDisfigurementOrDisabilityType;
    /**
     * Describe the condition.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f11bf11InjuryWillResultInDisfigurementOrDisabilityDescription?: string;
    /**
     * The date the patient was disabled from.
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f12PatientDisabledFromDate?: string;
    /**
     * The date the patient was disabled through.
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f12PatientDisabledThroughDate?: string;
    /**
     * The date the patient may return to work.
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f13PatientReturnToWorkDate?: string;
    /**
     * Does the patient require rehab?
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f14PatientRequiresRehab?: boolean;
    /**
     * Describe the recommendation.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f14PatientRequiresRehabRecommendation?: string;
    /**
     * Service items
     * OpenAPI data type: {array}
     * @type {Array<ProviderNynf3TemplateServiceLine>}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f15ServiceLines?: Array<ProviderNynf3TemplateServiceLine>;
    /**
     * Patient still under physician care.
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f18PatientStillUnderPhysicianCare?: boolean;
    /**
     * Estimated duration of future treatment.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f19EstimatedDurationOfFutureTreatment?: string;
    /**
     * Provider sign date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f21ProviderSignDate?: string;
    /**
     * Original signature of parties on file.
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f21OriginalSignatureOfPartiesOnFile?: boolean;
    /**
     * Original signature of parties on file date.
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    f21OriginalSignatureOfPartiesOnFileDate?: string;
    /**
     * The chargemaster item id that enforces the information in the service line
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderNynf3ClaimTemplateBodyWithClaimBody
     */
    chargemasterItemId?: string;
}

export function ProviderNynf3ClaimTemplateBodyWithClaimBodyFromJSON(json: any): ProviderNynf3ClaimTemplateBodyWithClaimBody {
    return {
                'f00DateOfAccident': !exists(json, 'f00DateOfAccident') ? undefined : json['f00DateOfAccident'],
                'f00ClaimNumber': !exists(json, 'f00ClaimNumber') ? undefined : json['f00ClaimNumber'],
                'f05DiagnosisAndConcurrentConditions': !exists(json, 'f05DiagnosisAndConcurrentConditions') ? undefined : (json['f05DiagnosisAndConcurrentConditions'] as Array<any>).map(ProviderNynf3DiagnosisAndCurrentConditionFromJSON),
                'f06DateSymptomsFirstAppeared': !exists(json, 'f06DateSymptomsFirstAppeared') ? undefined : json['f06DateSymptomsFirstAppeared'],
                'f07DatePatientConsulted': !exists(json, 'f07DatePatientConsulted') ? undefined : json['f07DatePatientConsulted'],
                'f08PatientEverHadSimilarCondition': !exists(json, 'f08PatientEverHadSimilarCondition') ? undefined : json['f08PatientEverHadSimilarCondition'],
                'f08PatientEverHadSimilarConditionDescription': !exists(json, 'f08PatientEverHadSimilarConditionDescription') ? undefined : json['f08PatientEverHadSimilarConditionDescription'],
                'f09ConditionDueToAutoAccident': !exists(json, 'f09ConditionDueToAutoAccident') ? undefined : json['f09ConditionDueToAutoAccident'],
                'f09ConditionDueToAutoAccidentDescription': !exists(json, 'f09ConditionDueToAutoAccidentDescription') ? undefined : json['f09ConditionDueToAutoAccidentDescription'],
                'f10ConditionDueToEmployment': !exists(json, 'f10ConditionDueToEmployment') ? undefined : json['f10ConditionDueToEmployment'],
                'f10ConditionDueToEmploymentDescription': !exists(json, 'f10ConditionDueToEmploymentDescription') ? undefined : json['f10ConditionDueToEmploymentDescription'],
                'f11InjuryResultInDisfigurementOrDisability': !exists(json, 'f11InjuryResultInDisfigurementOrDisability') ? undefined : Nynf3InjuryResultInDisfigurementOrDisabilityTypeFromJSON(json['f11InjuryResultInDisfigurementOrDisability']),
                'f11bf11InjuryWillResultInDisfigurementOrDisabilityDescription': !exists(json, 'f11bf11InjuryWillResultInDisfigurementOrDisabilityDescription') ? undefined : json['f11bf11InjuryWillResultInDisfigurementOrDisabilityDescription'],
                'f12PatientDisabledFromDate': !exists(json, 'f12PatientDisabledFromDate') ? undefined : json['f12PatientDisabledFromDate'],
                'f12PatientDisabledThroughDate': !exists(json, 'f12PatientDisabledThroughDate') ? undefined : json['f12PatientDisabledThroughDate'],
                'f13PatientReturnToWorkDate': !exists(json, 'f13PatientReturnToWorkDate') ? undefined : json['f13PatientReturnToWorkDate'],
                'f14PatientRequiresRehab': !exists(json, 'f14PatientRequiresRehab') ? undefined : json['f14PatientRequiresRehab'],
                'f14PatientRequiresRehabRecommendation': !exists(json, 'f14PatientRequiresRehabRecommendation') ? undefined : json['f14PatientRequiresRehabRecommendation'],
                'f15ServiceLines': !exists(json, 'f15ServiceLines') ? undefined : (json['f15ServiceLines'] as Array<any>).map(ProviderNynf3TemplateServiceLineFromJSON),
                'f18PatientStillUnderPhysicianCare': !exists(json, 'f18PatientStillUnderPhysicianCare') ? undefined : json['f18PatientStillUnderPhysicianCare'],
                'f19EstimatedDurationOfFutureTreatment': !exists(json, 'f19EstimatedDurationOfFutureTreatment') ? undefined : json['f19EstimatedDurationOfFutureTreatment'],
                'f21ProviderSignDate': !exists(json, 'f21ProviderSignDate') ? undefined : json['f21ProviderSignDate'],
                'f21OriginalSignatureOfPartiesOnFile': !exists(json, 'f21OriginalSignatureOfPartiesOnFile') ? undefined : json['f21OriginalSignatureOfPartiesOnFile'],
                'f21OriginalSignatureOfPartiesOnFileDate': !exists(json, 'f21OriginalSignatureOfPartiesOnFileDate') ? undefined : json['f21OriginalSignatureOfPartiesOnFileDate'],
                'chargemasterItemId': !exists(json, 'chargemasterItemId') ? undefined : json['chargemasterItemId'],
        ...ProviderNynf3ClaimTemplateBodyFromJSON(json)
    };

}

export function ProviderNynf3ClaimTemplateBodyWithClaimBodyToForm(value?: ProviderNynf3ClaimTemplateBodyWithClaimBody): any {
    let jsonVal = ProviderNynf3ClaimTemplateBodyWithClaimBodyToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderNynf3ClaimTemplateBodyWithClaimBodyToJSON(value?: ProviderNynf3ClaimTemplateBodyWithClaimBody): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'f00DateOfAccident': cleanupBlankValuesForBackend(value.f00DateOfAccident),
            'f00ClaimNumber': cleanupBlankValuesForBackend(value.f00ClaimNumber),
            'f05DiagnosisAndConcurrentConditions': (value.f05DiagnosisAndConcurrentConditions === undefined || value.f05DiagnosisAndConcurrentConditions === null) ? undefined  : (value.f05DiagnosisAndConcurrentConditions as Array<any>).map(ProviderNynf3DiagnosisAndCurrentConditionToJSON),
            'f06DateSymptomsFirstAppeared': cleanupBlankValuesForBackend(value.f06DateSymptomsFirstAppeared),
            'f07DatePatientConsulted': cleanupBlankValuesForBackend(value.f07DatePatientConsulted),
            'f08PatientEverHadSimilarCondition': cleanupBlankValuesForBackend(value.f08PatientEverHadSimilarCondition),
            'f08PatientEverHadSimilarConditionDescription': cleanupBlankValuesForBackend(value.f08PatientEverHadSimilarConditionDescription),
            'f09ConditionDueToAutoAccident': cleanupBlankValuesForBackend(value.f09ConditionDueToAutoAccident),
            'f09ConditionDueToAutoAccidentDescription': cleanupBlankValuesForBackend(value.f09ConditionDueToAutoAccidentDescription),
            'f10ConditionDueToEmployment': cleanupBlankValuesForBackend(value.f10ConditionDueToEmployment),
            'f10ConditionDueToEmploymentDescription': cleanupBlankValuesForBackend(value.f10ConditionDueToEmploymentDescription),
            'f11InjuryResultInDisfigurementOrDisability': Nynf3InjuryResultInDisfigurementOrDisabilityTypeToJSON(value.f11InjuryResultInDisfigurementOrDisability),
            'f11bf11InjuryWillResultInDisfigurementOrDisabilityDescription': cleanupBlankValuesForBackend(value.f11bf11InjuryWillResultInDisfigurementOrDisabilityDescription),
            'f12PatientDisabledFromDate': cleanupBlankValuesForBackend(value.f12PatientDisabledFromDate),
            'f12PatientDisabledThroughDate': cleanupBlankValuesForBackend(value.f12PatientDisabledThroughDate),
            'f13PatientReturnToWorkDate': cleanupBlankValuesForBackend(value.f13PatientReturnToWorkDate),
            'f14PatientRequiresRehab': cleanupBlankValuesForBackend(value.f14PatientRequiresRehab),
            'f14PatientRequiresRehabRecommendation': cleanupBlankValuesForBackend(value.f14PatientRequiresRehabRecommendation),
            'f15ServiceLines': (value.f15ServiceLines === undefined || value.f15ServiceLines === null) ? undefined  : (value.f15ServiceLines as Array<any>).map(ProviderNynf3TemplateServiceLineToJSON),
            'f18PatientStillUnderPhysicianCare': cleanupBlankValuesForBackend(value.f18PatientStillUnderPhysicianCare),
            'f19EstimatedDurationOfFutureTreatment': cleanupBlankValuesForBackend(value.f19EstimatedDurationOfFutureTreatment),
            'f21ProviderSignDate': cleanupBlankValuesForBackend(value.f21ProviderSignDate),
            'f21OriginalSignatureOfPartiesOnFile': cleanupBlankValuesForBackend(value.f21OriginalSignatureOfPartiesOnFile),
            'f21OriginalSignatureOfPartiesOnFileDate': cleanupBlankValuesForBackend(value.f21OriginalSignatureOfPartiesOnFileDate),
            'chargemasterItemId': cleanupBlankValuesForBackend(value.chargemasterItemId),
            ...ProviderNynf3ClaimTemplateBodyToJSON(value)
    };
}


